import React from "react";
import bg from "./bg.jpg";
import arrow from "./arrow.svg";
import "./Banner.scss";

import graduation from "../imgs/rga_1.jpeg";
import winter from "../imgs/rga_2.jpeg";
import diogo from "../imgs/diogo.jpg";

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <div className="banner">
        <div className="bbgtitlewrapper">
          <div className="bbgtitle">
            <img className="arrow" src={arrow} alt="Arrow" /> &nbsp; Next
            Events: &nbsp;{" "}
            <img className="arrow rotated" src={arrow} alt="Arrow" />
          </div>
        </div>
        <div>
          {/* <img className="cover" src={winter} alt="Winter camp" /> */}
          <img className="cover" src={diogo} alt="Diogo Primo seminar" />
        </div>
      </div>
    );
  }
}

export default Banner;
